// in api this is ProductApiModel
export default class ExternalProductApiModel {
  constructor(rawModel) {
    this.ExternalProductIds = rawModel?.ExternalProductIds || null
    this.NameInternal = rawModel?.NameInternal || null
    this.ResourceName = rawModel?.ResourceName || null
    this.ModifiedDurationInMinutes = rawModel?.ModifiedDurationInMinutes || null
    this.ModifiedCapacity = rawModel?.ModifiedCapacity || null
    this.ResourceKey = rawModel?.ResourceKey || null
    this.PricePerPerson = rawModel?.PricePerPerson || null
    this.PricePerTeam = rawModel?.PricePerTeam || null
    this.PricePerResource = rawModel?.PricePerResource || null
  }
}
